export enum UserDirectoryCompanyState {
  Registered = 'Registered',
  CanBeRegistered = 'CanBeRegistered',
}
